module.exports = __webpack_public_path__ + "img/onderdelen_header_small.299c53a3.webp";